import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <Section tone="canvas" title="What healthcare professionals are saying" subtitle="Clinicians who wanted a clearer structure for their obesity consultations." cta="I want this structure in my practice" ctaNote="One-Time Payment of $27 USD · Instant Download · 7-Day Guarantee" data-id="element-254" data-mp="3fzntdk80p90u">
      <div className="grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-255" data-mp="31zd1cduz1oe3">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-card sm:p-7" data-id="element-256" data-mp="2x09uqozcfa40">
            <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-257" data-mp="2s28bo41x3asj">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-258" data-mp="v8ndvg960vl9" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 flex-1 text-[17px] leading-relaxed text-ink" data-id="element-259" data-mp="q8ivfkop5qse">“{t.quote}”</blockquote>
            <figcaption className="mt-6 flex items-center gap-4 border-t border-line pt-5" data-id="element-260" data-mp="m51cjvsy5da0">
              <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand-soft" loading="lazy" data-id="element-261" data-mp="m2oor20ic8p1" />
              <div data-id="element-262" data-mp="zwpl5p3zljm8">
                <p className="font-bold text-ink" data-id="element-263" data-mp="zxh9cev98f2h">{t.name}</p>
                <p className="text-sm text-muted" data-id="element-264" data-mp="14vj25rihfsr5">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>
    </Section>;
}